import { render, staticRenderFns } from "./viewCompetency.vue?vue&type=template&id=0864c22e&"
import script from "./viewCompetency.vue?vue&type=script&lang=js&"
export * from "./viewCompetency.vue?vue&type=script&lang=js&"
import style0 from "./viewCompetency.vue?vue&type=style&index=0&id=0864c22e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports